var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"clearAllButton"}},[_c('button',{staticClass:"btn-clear-all",on:{"click":_vm.clearChecked}},[_vm._v(_vm._s(_vm._f("trans")('clear_all')))])])}
var staticRenderFns = []

export { render, staticRenderFns }